<template>
  <el-container>
    <el-header height="80px">
      <el-button
        type="primary"
        icon="el-icon-back"
        circle
        class="back-button"
        @click="$router.go(-1)"
      />
      <HttpRecordCell :record="this.record">
        <div slot="middle-content" class="identifiers">
          <div>
            <div class="identifier-title">Record identifier</div>
            <el-tag
              class="identifier-content"
              size="mini"
              v-clipboard:copy="this.record.id"
              v-clipboard:success="copySuccess"
            >{{ this.record.id || "None" }}</el-tag>
          </div>
          <div>
            <div class="identifier-title">User identifier</div>
            <el-tag
              class="identifier-content"
              size="mini"
              v-clipboard:copy="this.record.user_identifier"
              v-clipboard:success="copySuccess"
            >{{ this.record.user_identifier || "None" }}</el-tag>
          </div>
          <div>
            <div class="identifier-title">Device identifier</div>
            <el-tag
              class="identifier-content"
              size="mini"
              v-clipboard:copy="this.record.device_identifier"
              v-clipboard:success="copySuccess"
            >{{ this.record.device_identifier || "None" }}</el-tag>
          </div>
        </div>
      </HttpRecordCell>
    </el-header>
    <el-main>
      <HttpRecordContent :content="this.record.request" />
      <HttpRecordContent :content="this.record.response" :isResponse="true" :statusCode="this.record.status" />
    </el-main>
  </el-container>
</template>

<script>
import HttpRecordCell from "./HttpRecordCell.vue";
import HttpRecordContent from "./HttpRecordContent.vue";

export default {
  props: ["record"],
  components: {
    HttpRecordCell,
    HttpRecordContent
  },
  methods: {
    copySuccess() {
      this.$message({
        message: "Copied successfully",
        type: "success",
        duration: 1500
      });
    }
  }
};
</script>

<style scoped lang="sass">

.back-button
  margin-right: 15px

.identifiers                    // Layout identifiers
  @include flex($h: space-around, $v:center)
  width: 100%

  > *
    @include flex($h: center, $v:center)
    flex-direction: column

.identifier-title
  font-size: 0.7em
  color: $--color-text-secondary
  margin-bottom: 5px

.identifier-content
  cursor: copy
  font-family: "Recursive" !important

</style>